<template>
  <div class="page-wrapper storybook-cnc-checkbox">
    <StorybookTemplate title="CncCheckboxGroup" pathComponent="/shared/elements/global/v1/CncCheckboxGroup.vue" :pathFigma="pathFigma" :propList="propList" :desc="desc" :form.sync="form">
      <CncCheckboxGroup v-bind="form">{{ form.name }}</CncCheckboxGroup>
    </StorybookTemplate>
  </div>
</template>

<script>
export default {
  components: {
    StorybookTemplate: () => import('../../../../components/StorybookTemplate.vue')
  },
  data () {
    return {
      pathFigma: 'https://www.figma.com/file/QGmzH850ARJRAeL8BuBAer/%5BWEB%5D-Shared-Components?node-id=3431%3A124225&mode=dev',
      desc: 'วิธีการใช้ CncCheckboxGroup จะแตกต่างจาก <el-checkbox-group/> ตรงที่สามารถใส่ choices มาใน prop ได้เลย และสามารถ custom title, desc, icon ส่วน error การ validate from สามารถ ใส่ได้ที่ prop ของ error message หรือ จะใช้งานแบบเดิม (rules form) ก็ได้',
      propList: [
        { name: 'title', type: 'input', param: 'title', default: '' },
        { name: 'desc', type: 'input', param: 'desc', default: '' },
        { name: 'hasIndeterminate', type: 'boolean', required: true },
        { name: 'disabled', type: 'boolean', required: false },
        { name: 'isError', type: 'boolean', required: false },
        { name: 'errMessage', type: 'input', param: 'errMessage', default: '' },
        {
          name: 'size',
          type: 'select',
          param: 'size',
          default: 'small',
          option: [
            { label: 'small', name: 'Small' },
            { label: 'medium', name: 'Medium' }
          ]
        },
        {
          name: 'orientation',
          type: 'select',
          param: 'orientation',
          default: 'vertical',
          option: [
            { label: 'vertical', name: 'Vertical' },
            { label: 'horizontal', name: 'Horizontal' }
          ]
        },
        {
          name: 'rightIcon',
          type: 'object',
          param: 'rightIcon',
          objectKey: [
            { key: 'name', type: 'input', value: 'info' },
            { key: 'type', value: 'svg', type: 'select', option: ['svg', 'icon'] }
          ]
        }
      ],

      form: {
        title: 'Checkbox group label',
        desc: 'This is a hint message.',
        errMessage: 'This is an error message.',
        size: 'medium',
        hasIndeterminate: false,
        rightIcon: { type: 'icon', name: 'info' },
        orientation: 'vertical',
        choices: [ { id: 1, name: 'Checkbox1' }, { id: 2, name: 'Checkbox2' }, { id: 3, name: 'Checkbox3' }, { id: 4, name: 'Checkbox4' }, { id: 5, name: 'Checkbox5' }]
      }
    }
  }
}
</script>
